import React from 'react'
import { useNavigate } from "react-router-dom";
import TableDataStock from './Table/TableDataStock';

export default function Stock() {
  const Navigate = useNavigate();

  return (
    <div>
    
    <div className="flex mt-8 flex-wrap justify-center">
      <div
        className="tabelcontainer flex-auto  overflow-auto mx-4"
        // "w-[calc(100vw_-_12rem)]"
      >

      <TableDataStock/>
      </div>
    </div>
    <div className="flex flex-row justify-center float-left mt-12 mb-0 my-10">
    <button
      type="button"
      className="text-red-600 font-Montserrat font-medium text-lg"
      onClick={() => Navigate("/dashboard/warehouse/warehouse-list")}
    >
      Go Back
    </button>
    
  </div>
    </div>
  )
}
